export function parseSesion(
  {
    username,
    signInUserSession,
    keyPrefix,
    userDataKey,
    attributes,
    isFederated = false
  }
) {
  return {
    username,
    signInUserSession,
    keyPrefix,
    userDataKey,
    attributes,
    isFederated
  };
}

export default parseSesion;
